import { useState } from "react";
import { useMutation } from "@apollo/client";
import { Box, Button, Paper, Stack, Typography } from "@mui/material";
import { useIntl, FormattedMessage } from "react-intl";
import { CREATE_CONVERSATION } from "../../../graphql/mutations/DirectMessageContext";
import { useMessagingContext } from "../../../hooks/Messaging";

const PendingConversation = ({ activePendingConversation, onConversationAdded }) => {
  const intl = useIntl();
  const [createConversation, { loading, error }] = useMutation(CREATE_CONVERSATION);
  const [hasRequested, setHasRequested] = useState(false);

  const { removePendingConversation  } = useMessagingContext();

  const handleSendRequest = async () => {
    try {
      const userId = activePendingConversation?.userId;
      if (!userId) throw new Error("Missing userId in conversation");

      const res = await createConversation({ variables: { userIds: [userId] } });

      const createdConversation = res?.data?.directMessageContext?.createConversation;

      if (createdConversation) {
        onConversationAdded({ conversation: createdConversation });
        setHasRequested(true);
        removePendingConversation(userId);
      }
    } catch (err) {
      console.error("Conversation request failed", err);
    }
  };

  const memberName = activePendingConversation?.name || "…";

  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-end",
        position: "relative",
        height: "100%",
        pb: 2,
      }}
    >
      <Paper
        elevation={3}
        sx={{
          px: 3,
          py: 2,
          borderRadius: 2,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 2,
          bgcolor: "background.paper",
        }}
      >
        <Typography>
          {hasRequested ? (
            <FormattedMessage id="messaging.requestSent" />
          ) : (
              <FormattedMessage id="messaging.sendRequestTo" values={{ name: memberName }} />
            )}
        </Typography>

        {!hasRequested && (
          <Stack direction="row" spacing={2}>
            <Button
              onClick={handleSendRequest}
              variant="contained"
              disabled={loading}
              color="primary"
            >
              {loading ? (
                intl.formatMessage({ id: "common.genericLoading" })
              ) : (
                  <FormattedMessage id="btn.send" />
                )}
            </Button>
          </Stack>
        )}

        {error && (
          <Typography color="error" variant="body2">
            {error.message}
          </Typography>
        )}
      </Paper>
    </Box>
  );
};

export default PendingConversation;
